<template>
    <div>
      <div class="reconciliation">
        <div class="reconciliation-one">
          <div class="reconciliationFrom">
            <el-form :model="invoice"
                     :inline="true"
                     ref="invoice"
                     size="mini"
                     class="demo-ruleForm"
                     label-position="left">
                <el-form-item label="时间:">
                    <el-date-picker
                        v-model="value"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>    
                <el-form-item label="是否开票:"
                            prop="is_bill">
                    <el-select placeholder="请选择"
                           v-model="invoice.is_bill" clearable  >
                        <el-option v-for="item in billList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value+''">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否确认:"
                            prop="is_partner_true">
                    <el-select placeholder="请选择"
                           v-model="invoice.is_partner_true" clearable  >
                        <el-option v-for="item in partnerList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value+''">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <div class="flex">
                    <div class="sub" v-if="active=='first'" @click="checkInfo()">查询</div>
                    <div class="sub" v-else @click="checkStatus()">查询</div>
                    <div class="sadd" @click="addCheck()">新增对账单</div>
                    </div>
                </el-form-item>
            </el-form>
          </div>
          <div class="reconciliationTable">
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="ID"
                >
                </el-table-column>
                <el-table-column
                    prop="check_no"
                    label="对账单号"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="check_price"
                    label="账单金额"
                   >
                </el-table-column>
                <el-table-column
                    prop="payment_price"
                    label="结算金额"
                   >
                </el-table-column>
                <el-table-column
                    prop="point"
                    label="商务扣点"
                   >
                    <template slot-scope="scope">
                        <span>{{scope.row.point+"%"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="create_time"
                    label="创建日期"
                    show-overflow-tooltip
                   >
                </el-table-column>
                <el-table-column
                    prop="payment_time"
                    label="收款时间"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    prop="is_payment"
                    label="是否打款"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_payment==2">平台确认已打款</span>
                        <span v-show="scope.row.is_payment==1">已打款</span>
                        <span v-show="scope.row.is_payment==0">未打款</span>
                    </template>
                </el-table-column>
                    <el-table-column
                    prop="is_bill"
                    label="是否开票"
                   >
                   <template slot-scope="scope">
                    <el-link v-show="scope.row.is_bill==1" @click="detail(scope.row)" type="primary">查看发票</el-link>
                        <!-- <span v-show="scope.row.is_bill==1">查看发票</span> -->
                        <span v-show="scope.row.is_bill==0">未开票</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="is_partner_true"
                    label="是否确认订单"
                    >
                    <template slot-scope="scope">
                        <span v-show="scope.row.is_partner_true==1">是</span>
                        <span v-show="scope.row.is_partner_true==0">否</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="bill_url"
                    label="开票地址"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="order_count"
                    label="订单数量">
                </el-table-column>
                
                <el-table-column
                    prop="invoice_time"
                    label="开票时间"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="express"
                    label="快递单号"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    width="200px">
                    <template slot-scope="scope">
                        <el-button @click="detailsClick(scope.row)" type="text" size="small">订单详情</el-button>
                        <el-button @click="setStatus(scope.row)" type="text" size="small" v-if="scope.row.is_partner_true==0">确认对账单</el-button>
                        <el-button @click="payStatus(scope.row)" type="text" size="small" v-if="scope.row.is_partner_true==1&&scope.row.is_payment==0">确认打款</el-button>
                    </template>
                </el-table-column>
            </el-table>
          </div>
            <div class="goods-paging d-flex align-items-center justify-content-center">
				<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="limit"
					:hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
			</div>
        </div>
      </div>
      <div>
        <el-dialog
            title="未对账列表"
            :visible.sync="checkVisible"
            width="1080px"
            :before-close="handleClose">
            <unReconciled @close="close"></unReconciled>
        </el-dialog>
      </div>
      <div>
        <el-dialog
            :visible.sync="detailsVisible"
            width="1080px"
            :before-close="handleClose">
            <Details :detailsList="detailsList"></Details>
        </el-dialog>
      </div>
     
    </div>
</template>
<script>
  import './reconciliation.css'
  import unReconciled from './unreconciled.vue'
  import Details from './details.vue'
  export default {
    props:['active'],
    components:{
        unReconciled,Details
    },
    data() {
      return {
        checkVisible:false,
        detailsVisible:false,
        value:[],
        invoice:{
            start_time:"",
            end_time:"",
            is_bill:"",
            is_partner_true:"",
        },
        
        currentPage: 1, //页数
		ttshop_znum: 0, //总商品数
		limit: 9, //每页条数
		page_count: '', //总页数
        partnerList: [{value: 1,label: '是'},{value: 2,label: '否'}
        ],
        billList:[{value:1,label: '是'},{value:0,label: '否'},],
        tableData: [],
        detailsList:{}
      }
    },
    created() {
        // console.log(this.active,"active")
        if(this.active=="first"){
            this.checkInfo()
        }else{
            this.checkStatus()
        }
    //  this.checkInfo()
    },
    watch: {
        active:{
            handler(newName, oldName){
                this.active= newName
                if( this.active=="first"){
                    this.checkInfo()
                }else{
                    this.checkStatus()
                }
            }
        }
    },
    mounted() {},
    methods: {
        // 查看发票
        detail(row){
            window.open(row.bill_url[0])
            // console.log(row.bill_url[0],"bill_url")
        },
        // 新增对账单
        addCheck(){
            this.checkVisible=true
        },
        close(){
            this.checkVisible=false
            
        },
        handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
        },
        // 分页
        handleCurrentChange(e) {
				this.currentPage= e;
				if(this.active=="first"){
					this.checkInfo()
				}else {
					this.checkStatus();
				}
		},
        // 初次回显对账列表——待付款
        checkInfo() {
            this.$api
            .checkOrderlist({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token
                status:2,
                start_time: this.value && this.value.length ? this.value[0] : '',
                end_time: this.value && this.value.length ? this.value[1] : '',
                // start_time:this.invoice.start_time,
                // end_time:this.invoice.end_time,
                is_bill:this.invoice.is_bill,
                is_partner_true:this.invoice.is_partner_true,
                page: this.currentPage,
                limit: this.limit,
            })
            .then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                        this.ttshop_znum = Number(res.data.row_count);
                        this.page_count = res.data.page_count;
                } else {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                })
                }
            })
            .catch(err => {
                // console.log(err);
            })
        },
        // 初次回显对账列表——已付款
        checkStatus() {
            this.$api
            .checkOrderlist({
                shop_type: 'qycg',
                // access_token: this.$store.state.qycg_user.access_token
                status:1,
                start_time: this.value && this.value.length ? this.value[0] : '',
                end_time: this.value && this.value.length ? this.value[1] : '',
                is_bill:this.invoice.is_bill,
                is_partner_true:this.invoice.is_partner_true,
                page: this.currentPage,
                limit: this.limit,
            })
            .then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list;
                        this.ttshop_znum = Number(res.data.row_count);
                        this.page_count = res.data.page_count;
                } else {
                this.$message({
                    showClose: true,
                    message: res.msg,
                    type: 'warning',
                    offset: 200,
                    duration: 1000
                })
                }
            })
            .catch(err => {
                // console.log(err);
            })
        },
        // 确认对账单
        setStatus(row) {
            this.$confirm('确认当前对账单吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					this.$api.setOrderstatus({
						shop_type: 'qycg',
                        check_id:row.id
					}).then(res => {
                        if(res.code==0){
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'success',
                                offset: 200,
                                duration: 1000
                            })
                            this.checkInfo()
                            this.checkStatus()
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'warning',
                                offset: 200,
                                duration: 1000
                            })
                        }
					}).catch(err => {
						// console.log(err);
					});
				}).catch(() => {});
        },
        // 确认打款
        payStatus(row){
            this.$confirm('确认打款吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(() => {
					this.$api.setPaymentstatus({
						shop_type: 'qycg',
                        check_id:row.id
					}).then(res => {
                        if(res.code==0){
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'success',
                                offset: 200,
                                duration: 1000
                            })
                            this.checkInfo()
                            this.checkStatus()
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'warning',
                                offset: 200,
                                duration: 1000
                            })
                        }
					}).catch(err => {
						// console.log(err);
					});
                }).catch(() => {});
        },
        // 订单详情
        detailsClick(row){
            this.detailsList=row
            this.detailsVisible=true
        }
    }
  }
</script>
<style lang="scss" scoped>
  .reconciliation {
    width: 100%;
    // background-color: #f2f2f2;
    // padding-top: 20px;
    .reconciliation-one {
      margin: 0 auto;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        .purHead{
          width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-radius: 6px;
            box-sizing: border-box;
            padding: 10px 30px 12px 30px;
            line-height: 16px;
          }
      
      .reconciliationFrom {
        width: 100%;
        padding: 24px 15px 0px 20px;
        box-sizing: border-box;
        margin: 0 auto;
  
        .flex {
          display: flex;
        }
        .sub {
          cursor: pointer;
          width: 70px;
          height: 32px;
          background: #ff0e25;
          border-radius: 2px;
          color: #fff;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          text-align: center;
          
        }
        .sadd{
            cursor: pointer;
              width: 80px;
              height: 32px;
              background: #ff0e25;
              border-radius: 2px;
              color: #fff;
              line-height: 32px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              text-align: center;
              margin-left: 5px;
        }
      }
      .reconciliationTable{
        // padding: 0px 15px 24px 20px;
      }
      .reconciliation_pages{
            display: flex;
            width: 100%;
			margin-top: 20px;
            justify-content: space-between;
      }
    }
  }
</style>